import React, { useState } from 'react';
import { ManagePhoneNumbersVerifyPassword } from './ManagePhoneNumbersVerifyPassword';
import { ManagePhoneNumbersPhoneEntry } from './ManagePhoneNumbersPhoneEntry';
import { ManagePhoneNumbersPhoneOTPVerify } from './ManagePhoneNumbersPhoneOTPVerify';
import { useSteps } from '@workday/upc-common';

interface ManagePhoneNumbersModalStepsProps {
    userInfo: any;
    handleDone: () => void;
}

export function ManagePhoneNumbersModalSteps({ userInfo, handleDone }: ManagePhoneNumbersModalStepsProps) {
    const { next, previous, currentStep } = useSteps();
    const [phoneContact, setPhoneContact] = useState({});

    return currentStep === 0 ? (
        <ManagePhoneNumbersVerifyPassword onNext={next} handleDone={handleDone} />
    ) : currentStep === 1 ? (
        <ManagePhoneNumbersPhoneEntry
            userInfo={userInfo}
            handleDone={handleDone}
            setPhoneContact={setPhoneContact}
            onNext={next}
        />
    ) : currentStep === 2 ? (
        <ManagePhoneNumbersPhoneOTPVerify
            phoneContact={phoneContact}
            onPrevious={previous}
            handleDone={handleDone}
            userInfo={userInfo}
        />
    ) : null;
}
